import { InsightsNavbar } from "@/components/InsightsNavbar";
import { TakeawayBanner } from "@/components/TakeawayBanner";
import { FounderQuote } from "@/components/FounderQuote";
import { KeyFindingsSection } from "@/components/KeyFindingsSection";
import { DecemberDeliverabilitySection } from "@/components/DecemberDeliverabilitySection";
import { QuarterComparisonChart } from "@/components/QuarterComparisonChart";
import { IndustryBenchmarksSection } from "@/components/IndustryBenchmarksSection";
import { ComparisonSection } from "@/components/ComparisonSection";
import { PracticalSection } from "@/components/PracticalSection";
import { AnimatedSection } from "@/components/AnimatedSection";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { DecemberHeroSection } from "@/components/insights/december/DecemberHeroSection";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const DecemberEmailDrop = () => {
  return (
    <>
      <InsightSEO 
        slug="december-email-drop" 
        additionalKeywords={["holiday email", "seasonal email", "email conversion rates", "Q4 email performance"]}
      />
      <InsightEngagementTracker slug="december-email-drop" title="December Email Drop" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Seasonal Analysis" 
          currentPage="December Email Drop" 
        />
        <DecemberHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <TakeawayBanner />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <FounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <KeyFindingsSection />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <DecemberDeliverabilitySection />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <QuarterComparisonChart />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <IndustryBenchmarksSection />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <ComparisonSection />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <PracticalSection />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="december-email-drop" />
        </AnimatedSection>
        
        {/* FAQ Section */}
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="december-email-drop" />
        </AnimatedSection>
        
        {/* Related Tools Section */}
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="december-email-drop" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default DecemberEmailDrop;
